import * as wjcCore from '@mescius/wijmo';
import * as wjGridFilter from '@mescius/wijmo.grid.filter';
import * as wjInput from '@mescius/wijmo.input';
import * as wjMultirow from '@mescius/wijmo.grid.multirow';

'use strict';

import {ViewChild, Component, AfterViewInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {HttpClient, HttpEventType, HttpRequest} from "@angular/common/http";
import {Store} from "@ngrx/store";
import {ToasterService} from "angular2-toaster";
import {TranslocoService} from '@jsverse/transloco';
import {ActivePromotionConfig} from "../config/active-promotion.config";
import {asOrientDate, isOrientDate, DataService, OrientDBCollectionView} from "@cosbeni/database";
import * as uuid from "uuid";
import {Observable} from 'rxjs';

@Component({
    standalone: false,
    selector: 'cj-admin-history',
    templateUrl: 'history-management.component.html'
})

export class HistoryManagementComponent implements AfterViewInit {
    readonly: Boolean = true;
    @ViewChild('historyGrid') historyGrid: wjMultirow.MultiRow;
    @ViewChild('buyerAutoComplete') buyerAutoComplete: wjInput.AutoComplete;
    @ViewChild('itemAutoComplete') itemAutoComplete: wjInput.AutoComplete;
    filter: wjGridFilter.FlexGridFilter;
    predicate: any = {
        id: null,
        place: "",
        lane: "",
        category: "",
        auctionResult: "",
        buyer: null,
        seller: null,
        name: "",
        description: "",
        eventDate: null,
    }
    screenWidth: number;
    history: any = {};
    histories: OrientDBCollectionView;
    mode: string = "view";
    optionAuctionResult: any[] = [];
    optionCategory: any[] = [];
    optionLane: any[] = [];
    optionMethod: any[] = [];
    optionPlace: any[] = [];
    optionUnit: any[] = [];

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService, private route: ActivatedRoute, private http: HttpClient, private transloco: TranslocoService) {
        this.histories = new OrientDBCollectionView(dataService, ActivePromotionConfig.DATABASE, "SELECT FROM DA_History", "DA_History", "", 0, 100, true, true, false)
        this.histories.url = ActivePromotionConfig.SERVER_URL;
        this.histories.tokenName = ActivePromotionConfig.DATABASE + "_token";
        this.histories.fetchPlan = "*:1";
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='セリ結果' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='セリ結果' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionAuctionResult = data.results;
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='商品種別' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='商品種別' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionCategory = data.results;
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='レーン' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='レーン' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionLane = data.results;
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='会場名' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='会場名' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionPlace = data.results;
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='単位' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='単位' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionUnit = data.results;
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='注文方法' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='注文方法' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionMethod = data.results;
            }
        })
        this.createNew();
        this.resizeScreen();
        this.mode = "view";
    }

    resizeScreen(event?) {
        this.screenWidth = window.innerWidth;
    }

    ngAfterViewInit() {
        this.histories.filterOnServer = true;
        this.histories.currentChanged.addHandler(this.onCurrentChanged, this);
        this.histories.itemsSourceFunction = function (items: any[]) {
            for (let item of items) {
                if (isOrientDate(item.historyDate)) {
                    item.historyDate = asOrientDate(item.historyDate);
                }
            }
            return items;
        }
    }

    onCurrentChanged(sender: any, args: wjcCore.EventArgs): void {
        if (this.histories.currentItem != null && this.mode == "view") {
            this.history = Object.assign({},this.histories.currentItem);
            if (wjcCore.isObject(this.history.buyer)) {
                this.buyerAutoComplete.itemsSource = new wjcCore.CollectionView([this.history.buyer]);
            }
            if (wjcCore.isObject(this.history.item)) {
                this.itemAutoComplete.itemsSource = new wjcCore.CollectionView([this.history.item]);
            }
        }
    }

    createNew(): void {
        this.mode = "edit";
        this.history = {
            "@class": "DA_History",
            "@rid": "#-1:-1",
            buyer: null,
            historyDate: new Date(),
            price: 0,
            item: null,
            uuid: uuid.v4().split("-").join("")
        }
    }

    editHistory(): void {
        this.mode = "edit";
        if (this.histories.currentItem != null) {
            this.history = Object.assign({}, this.histories.currentItem);
        }
    }

    cancelHistory(): void {
        this.mode = "view";
        if (this.histories.currentItem != null) {
            this.history = Object.assign({}, this.histories.currentItem);
        }
    }

    saveHistory(): void {
        this.saveHistory$().subscribe((response: any) => {
                this.toasterService.pop('info', this.transloco.translate('common.save'), this.transloco.translate('admin.saved_message'));
                this.dataService.query({
                    sql: "SELECT FROM DA_History WHERE uuid = '" + this.history.uuid + "'",
                    count: "SELECT FROM DA_History WHERE uuid = '" + this.history.uuid + "'",
                    fetchPlan: "*:1",
                }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                    if (data.results.length == 1) {
                        this.history = data.results[0];
                        if (isOrientDate(this.history.historyDate)) {
                            this.history.historyDate = asOrientDate(this.history.historyDate);
                        }
                    }
                    if (wjcCore.isObject(this.histories.currentItem) && this.histories.currentItem.uuid == this.history.uuid) {
                        let historiesArray = this.histories.sourceCollection;
                        let index = historiesArray.indexOf(this.histories.currentItem);
                        this.histories.sourceCollection[index] = this.history;
                        this.histories.refresh();
                        this.mode = "view";
                        if (wjcCore.isObject(this.history.buyer)) {
                            this.buyerAutoComplete.itemsSource = new wjcCore.CollectionView([this.history.buyer]);
                        }
                    }
                })
            },
            (error: any) => {
                this.toasterService.pop('error', this.transloco.translate('common.save'), this.transloco.translate('admin.failed_message'));
            }
        )
    }

    saveHistory$(): Observable<any> {
        let history = Object.assign({}, this.history);
        if (wjcCore.isDate(history.historyDate)) {
            history.historyDate = wjcCore.Globalize.formatDate(history.historyDate, 'yyyy-MM-dd HH:mm:ss');
        }
        let sql = "BEGIN\n"
        let mapItem: any[] = [];
        Object.entries(history).forEach(([key, value]) => {
            if (wjcCore.isNumber(value) && !key.startsWith("@")) {
                if (key != "id" && value != 0) {
                    mapItem.push(key + "=" + value)
                }
            } else if (key == "buyer") {
                if (wjcCore.isObject(value)) {
                    mapItem.push(key + "=" + value['@rid'])
                }
            } else if (key == "item") {
                if (wjcCore.isObject(value)) {
                    mapItem.push(key + "=" + value['@rid'])
                }
            } else {
                if (!key.startsWith("@") && value != null) {
                    if (wjcCore.isString(value)) {
                        let v: string = value;
                        v = v.replace(/\\/g, "\\\\");
                        v = v.replace(/\n/g, "\\n");
                        v = v.replace(/\t/g, "\\t");
                        v = v.replace(/'/g, "\\'");
                        v = v.replace(/"/g, '\\"');
                        value = v;
                    }
                    mapItem.push(key + "='" + value + "'")
                }
            }
        });
        if (history['@rid'] == "#-1:-1") {
            sql = sql + "let history = INSERT INTO DA_History SET " + mapItem.join(",") + " return $current\n";
        } else {
            sql = sql + "UPDATE DA_History SET " + mapItem.join(",") + " WHERE @rid = " + this.history['@rid'] + "\n";
        }
        sql = sql + "COMMIT RETRY 100\n";
        return this.dataService.batch({sql: sql}, ActivePromotionConfig.SERVER_URL);
    }

    search(): void {
        let where = [];
        if (wjcCore.isNumber(this.predicate.id)) {
            where.push("item.id = " + this.predicate.id);
        }
        if (wjcCore.isDate(this.predicate.eventDate)) {
            where.push("item.auction.eventDate >= date('" + wjcCore.Globalize.formatDate(this.predicate.eventDate, 'yyyy-MM-dd') + "','yyyy-MM-dd')");
            where.push("item.auction.eventDate < date('" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.predicate.eventDate, 1), 'yyyy-MM-dd') + "','yyyy-MM-dd')");
        }
        if (!wjcCore.isNullOrWhiteSpace(this.predicate.place)) {
            where.push("item.auction.place = '" + this.predicate.place + "'");
        }
        if (!wjcCore.isNullOrWhiteSpace(this.predicate.lane)) {
            where.push("item.auction.lane = '" + this.predicate.lane + "'");
        }
        if (!wjcCore.isNullOrWhiteSpace(this.predicate.category)) {
            where.push("item.category = '" + this.predicate.category + "'");
        }
        if (!wjcCore.isNullOrWhiteSpace(this.predicate.auctionResult)) {
            where.push("item.auctionResult = '" + this.predicate.auctionResult + "'");
        }
        if (!wjcCore.isNullOrWhiteSpace(this.predicate.name)) {
            where.push("item.name LIKE '%" + this.predicate.name + "%'");
        }
        if (!wjcCore.isNullOrWhiteSpace(this.predicate.description)) {
            where.push("item.description LIKE '%" + this.predicate.description + "%'");
        }
        this.histories.filterOnServer = false;
        this.histories.filterSpecial = where.join(" AND ")
        this.histories.filterOnServer = true;
    }

    resetPredicate() {
        this.predicate = {
            id: null,
            place: "",
            lane: "",
            category: "",
            auctionResult: "",
            buyer: null,
            seller: null,
            name: "",
            description: "",
            eventDate: null,
        }
        this.search();
    }

    getImageSrc(item, name): string {
        return ActivePromotionConfig.IMAGE_URL + item.id + '/' + name;
    }


    convertSize(fileSize: number) {
        return fileSize < 1024000 ? (fileSize / 1024).toFixed(2) + " KB" : (fileSize / 1024000).toFixed(2) + " MB";
    }

    getBuyerFunction(query: string, max: number, callback: Function) {
        if (!query) {
            callback(null);
            return;
        }
        let where = [];
        where.push("name LIKE '%" + query + "%'")
        where.push("memberName LIKE '%" + query + "%'")
        where.push("telephone LIKE '%" + query + "%'")
        this.dataService.query({
            sql: "SELECT FROM OUser WHERE status = 'ACTIVE' AND buyer = true AND (" + where.join(" OR ") + ")",
            count: "SELECT FROM OUser WHERE status = 'ACTIVE' AND buyer = true AND (" + where.join(" OR ") + ")",
            fetchPlan: "*:0",
        }, ActivePromotionConfig.SERVER_URL).subscribe(response => {
            if (wjcCore.isArray(response.results)) {
                callback(response.results);
            }
        })
    }

    getBuyer = this.getBuyerFunction.bind(this);

    getItemFunction(query: string, max: number, callback: Function) {
        if (!query) {
            callback(null);
            return;
        }
        let where = [];
        where.push("id = " + query)
        where.push("name LIKE '%" + query + "%'")
        where.push("description LIKE '%" + query + "%'")
        this.dataService.query({
            sql: "SELECT FROM DA_Item WHERE (" + where.join(" OR ") + ")",
            count: "SELECT FROM DA_Item WHERE (" + where.join(" OR ") + ")",
            fetchPlan: "*:0",
        }, ActivePromotionConfig.SERVER_URL).subscribe(response => {
            if (wjcCore.isArray(response.results)) {
                callback(response.results);
            }
        })
    }

    getItem = this.getItemFunction.bind(this);

}

